import Vue from 'vue'
import Router from 'vue-router'
import * as modules from './store/decorator'

import CCTVHistory from '@/resources/views/content/CCTVHistory.vue'
import CCTV from '@/resources/views/content/CCTV.vue'
import Manhole from '@/resources/views/content/Manhole.vue'
import KnowledgeBase from '@/resources/views/content/KnowledgeBase.vue'
import TabbedView from '@/resources/views/content/TabbedView.vue'
import Container from '@/resources/views/pages/Container.vue'
import Login from '@/resources/views/pages/Login.vue'
import Agreement from '@/resources/views/pages/Agreement.vue'
import NotFound from '@/resources/views/pages/NotFound.vue'

Vue.use(Router)

// note, these are different from the definitions in the base-networks definition
const cctv = {
    label: 'CCTV',
    // this is the type assigned to the surveys when stored
    code: 'cctv',
    // this controls the drop down menu and navigation
    surveys: [{
            title: 'CCTV',
            query: 'cctv',
            path: 'newcctv' // this is actually the target routes name
        },
        {
            title: 'Miscellaneous',
            query: 'miscellaneous',
            path: 'newmisc'
        }
    ],
    // this controls the available tabs
    options: [
        {
            title: 'History',
            icon: 'history',
            component: CCTVHistory
        },
        {
            title: 'Asset Locator',
            icon: 'cloud_queue',
            component: 'assetlocator'
        }
    ]
}

const wwater = {
    label: 'Wastewater',
    code: 'WW',
    surveys: [{
            title: 'Pipe Repair - After',
            disabled: true
        },
        {
            title: 'Pipe Repair - Before',
            disabled: true
        },
        {
            title: 'Trade Waste Trap',
            disabled: true
        },
        {
            title: 'Odour Compliant',
            disabled: true
        },
        {
            title: 'Inflow Inspection',
            query: 'inflow-inspection',
            path: 'newii'
        },
        {
            title: 'Manhole',
            query: 'manhole',
            path: 'newww'
        }
    ],
    options: [
        {
            title: 'History',
            icon: 'history',
            component: 'surveyhistory'
        },
        {
            title: 'Upload Queue',
            icon: 'cloud_queue',
            component: 'surveyqueue'
        }
    ]
}

const swater = {
    label: 'Stormwater',
    code: 'SW',
    surveys: [{
            title: 'Pipe Repair - After',
            disabled: true
        },
        {
            title: 'Pipe Repair - Before',
            disabled: true
        },
        {
            title: 'Outlet',
            disabled: true
        },
        {
            title: 'Sump / Catchpit',
            disabled: true
        },
        {
            title: 'Manhole',
            query: 'manhole',
            path: 'newsw'
        }
    ],
    options: [
        {
            title: 'History',
            icon: 'history',
            component: 'surveyhistory'
        },
        {
            title: 'Upload Queue',
            icon: 'cloud_queue',
            component: 'surveyqueue'
        }
    ]
}

const wsupply = {
    label: 'Water Supply',
    code: 'WS',
    surveys: [{
            title: 'Pipe Repair - After',
            disabled: true
        },
        {
            title: 'Pipe Repair - Before',
            disabled: true
        },
        {
            title: 'Valve Inspection',
            disabled: true
        },
        {
            title: 'Leak Detection',
            disabled: true
        }
    ],
    options: [
        {
            title: 'History',
            icon: 'history',
            component: 'surveyhistory'
        },
        {
            title: 'Upload Queue',
            icon: 'cloud_queue',
            component: 'surveyqueue'
        }
    ]
}

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                layout: 'Base'
            }
        },
        {
            path: '',
            name: 'home',
            redirect: {
                name: 'cctvmain', // route name
                params: {
                    network: 'cctv'
                }
            },
            meta: {
                auth: true,
                title: 'Login'
            }
        },
        {
            // I've added this everywhere to ensure the code that relies on $route.params.network will work - the router is not passing this one for some reason
            // and there is odd code in unexpected places that expects this value to be set
            beforeEnter: (to, from, next) => { 
                // @ts-ignore
                to.params.network = cctv
                next(to.params)
            },
            path: '/cctv',
            component: Container,
            props: { network: cctv }, // some pages (like the layouts) use this, but not all, go figure
            children: [
                {
                    path: '',
                    name: 'cctvmain',
                    component: TabbedView
                },
                {
                    path: 'new',
                    name: 'newcctv',
                    component: CCTV,
                    beforeEnter: (to, from, next) => {
                        // @ts-ignore
                        to.params.network = cctv
                        next(to.params)
                    }
                },
                {
                    path: 'newmisc',
                    name: 'newmisc',
                    component: CCTV,
                    beforeEnter: (to, from, next) => {
                        // @ts-ignore
                        to.params.network = cctv
                        next(to.params)
                    }
                },

            ],
            meta: {
                auth: true,
                title: 'CCTV'
            }
        },
        {
            beforeEnter: (to, from, next) => {
                // @ts-ignore
                to.params.network = wwater
                next(to.params)
            },
            path: '/wastewater',
            component: Container,
            props: { network: wwater },
            children: [
                {
                    path: '',
                    name: 'wwmain',
                    component: TabbedView,
                    beforeEnter: (to, from, next) => {
                        // @ts-ignore
                        to.params.network = wwater
                        next(to.params)
                    }
                },
                {
                    path: 'new',
                    name: 'newww',
                    component: Manhole,
                    meta: {
                        title: 'Wastewater - Manhole'
                    },
                    beforeEnter: (to, from, next) => {
                        // @ts-ignore
                        to.params.network = wwater
                        next(to.params)
                    }
                },
                {
                    path: 'new',
                    name: 'newii',
                    component: Manhole,
                    meta: {
                        title: 'Wastewater - Inflow Inspection'
                    },
                    beforeEnter: (to, from, next) => {
                        // @ts-ignore
                        to.params.network = wwater
                        next(to.params)
                    }
                },
            ],
            meta: {
                auth: true,
                title: 'Wastewater'
            }
        },
        {
            beforeEnter: (to, from, next) => {
                // @ts-ignore
                to.params.network = swater
                next(to.params)
            },
            path: '/stormwater',
            component: Container,
            props: { network: swater },
            children: [
                {
                    path: '',
                    name: 'swmain',
                    component: TabbedView,
                    beforeEnter: (to, from, next) => {
                        // @ts-ignore
                        to.params.network = swater
                        next(to.params)
                    }
                },
                {
                    path: 'new',
                    name: 'newsw',
                    component: Manhole,
                    meta: {
                        title: 'Stormwater - Manhole'
                    },
                    beforeEnter: (to, from, next) => {
                        // @ts-ignore
                        to.params.network = swater
                        next(to.params)
                    }
                },
            ],
            meta: {
                auth: true,
                title: 'Stormwater'
            }
        },
        {
            beforeEnter: (to, from, next) => {
                // @ts-ignore
                to.params.network = wsupply
                next(to.params)
            },
            path: '/watersupply',
            component: Container,
            props: { network: wsupply },
            children: [
                {
                    path: '',
                    name: 'wsmain',
                    component: TabbedView,
                    beforeEnter: (to, from, next) => {
                        // @ts-ignore
                        to.params.network = wsupply
                        next(to.params)
                    }
                },
                {
                    path: 'new',
                    name: 'newws',
                    component: Manhole,
                    meta: {
                        title: 'Water Supply - Manhole'
                    },
                    beforeEnter: (to, from, next) => {
                        // @ts-ignore
                        to.params.network = wsupply
                        next(to.params)
                    }
                },
            ],
            meta: {
                auth: true,
                title: 'Water Supply'
            }
        },
        {
            path: '/knowledge-base',
            name: 'knowledgeBase',
            component: KnowledgeBase,
            meta: {
                auth: true
            }
        },
        {
            path: '/agreement',
            name: 'agreement',
            component: Agreement,
            meta: {
                auth: true,
                skipAgreementCheck: true // Special flag to skip agreement checking for this route
            }
        },
        /* ------------------------------------
         *
         *          catchall 404
         *
         * ------------------------------------ */
        {
            path: '*',
            name: 'notFound',
            component: NotFound,
            meta: {
                layout: 'Base'
            }
        }
    ]
})

export default router
